import React from "react";
import UserModel from "../../model/UserModel";
import Coupons from "../redeemCoupon/Coupons";
import { EventEmitter } from "./../../events"


// Image imports
import pointsCoinImg from "../../assets/img/points-coin.svg";

export default class RedeemPoints extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      inCouponFlow: false, // ✅ Flag to control visibility
      shouldRefreshUser: false,
    };

    this.userModel = new UserModel();
    this.refreshUserData = this.refreshUserData.bind(this)
    
  }

  componentDidMount() {
    this.refreshUserData()
    // let user = this.userModel.GetUserFromLocal()
    // this.setState({ user: user })
    // console.log("did",user)
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.shouldRefreshUser && !prevState.shouldRefreshUser) {
      this.refreshUserData() 
    }
  }
  async refreshUserData() {
    let user = await this.userModel.GetUser()
    this.setState({ user: user })
    EventEmitter.dispatch("profileUpdated")
  }
  

  render() {
    // const coins = this.state.user.data?.userProfileStatics?.coins || 0;

    return (
      <div className="content step1" id="redeem-step1">
      {!this.state.inCouponFlow && (
        <div className="points-container">
          
            <div className="text-group">
              <h5>Points Earned:</h5>
              {/* <span className="point-box">${coins}</span> */}
              <span className="point-box">
                ${this.state.user?.data?.userProfileStatics?.coins ?? 0}
              </span>
            </div>
          
          <img src={pointsCoinImg} alt="Points Coin" className="coin-img" />
        </div>
      )}
        <Coupons
          coins={this.state.user.data?.userProfileStatics?.coins}
          onEnterCouponFlow={() => this.setState({ inCouponFlow: true })}
          // onExitCouponFlow={() => this.setState({ inCouponFlow: false })}
          onExitCouponFlow={() =>
            this.setState({
              inCouponFlow: false,
              shouldRefreshUser: true, // ✅ Trigger refresh once
            })
          }
        />
      </div>
    );
  }
}

